import { create } from "zustand";
import { loadSession, saveSession, type Session } from "@/lib/api";

type AuthState = {
  session: Session | null;
  setSession: (s: Session | null) => void;
  hasPerm: (perm: string) => boolean;
  logout: () => void;
};

export const useAuth = create<AuthState>((set, get) => ({
  session: loadSession(),
  setSession: (s) => {
    saveSession(s);
    set({ session: s });
  },
  hasPerm: (p) => {
    const perms = get().session?.user.perms ?? [];
    return perms.includes(p) || perms.includes("*");
  },
  logout: () => {
    saveSession(null);
    set({ session: null });
  },
}));
